import { memo } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { Button } from "@/components/ui/button/button";

import { InSaleStatusControl } from "./in-sale-status-control";

type Props = {
	previewButton?: {
		isValid: boolean;
		handleClick: () => void;
	};
	updateButton: {
		isValid: boolean;
		handleClick: () => void;
	};
	inSaleSwitch: {
		inSale: ForNodeType<boolean>;
		handleChangeInSale: (input: boolean | undefined) => void;
	};
};

export const HeaderUpdateButtonAndInSaleSwitch = memo(({ previewButton, updateButton, inSaleSwitch }: Props) => {
	return (
		<div className="flex w-full items-center justify-between gap-x-2 laptop:gap-x-4">
			<div className="flex flex-col gap-y-1">
				<InSaleStatusControl inSale={inSaleSwitch.inSale} onChange={inSaleSwitch.handleChangeInSale} />
				{inSaleSwitch.inSale.error ? (
					<p className="text-2xs text-error-600 laptop:text-xs">{inSaleSwitch.inSale.error}</p>
				) : null}
			</div>

			<div className="flex shrink-0 items-center gap-x-1.5 laptop:gap-x-4">
				{previewButton ? (
					<Button
						type="button"
						variant={previewButton.isValid ? "outline" : "disabled"}
						disabled={!previewButton.isValid}
						size={"sm"}
						className="whitespace-nowrap laptop:size-auto laptop:px-4 laptop:py-2"
						onClick={previewButton.handleClick}
						tooltip="実際に公開した場合の表示を確認できます"
					>
						保存してプレビュー
					</Button>
				) : null}

				<Button
					type="button"
					variant={updateButton.isValid ? "default" : "disabled"}
					disabled={!updateButton.isValid}
					size={"sm"}
					className="whitespace-nowrap laptop:size-auto laptop:px-6 laptop:py-2"
					onClick={updateButton.handleClick}
				>
					保存
				</Button>
			</div>
		</div>
	);
});
HeaderUpdateButtonAndInSaleSwitch.displayName = "HeaderUpdateButtonAndInSaleSwitch";
